import { Grid, Paper, Button } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import useReactHookForm from "hooks/useReactHookForm";
import ContentRight from "shared/molecules/content-right";
import { hasAtLeastOneValue, nl3LiveclassMasterInitialValues, nl3LiveclassMasterProperties, nl3LiveclassMasterValidationSchema } from "./helper";

export function Nl3LiveclassMasterFilter({ setSearchPayload,
  setPage,
}) {

    const { control, errors, getValues, watch, setValue } = useReactHookForm(
        nl3LiveclassMasterInitialValues,
        nl3LiveclassMasterValidationSchema,
        "",
    );

  const handleSearch = () => {

    const payload: any = {};

    const admissionNumber = watch("admissionNumber");
    if (admissionNumber) payload.admissionNumber = admissionNumber;
    
    const userName= watch("userName")
    if(userName) payload.searchName= userName;
    
    const nlearn3LiveclassPackageId = watch("nlearn3LiveclassPackageId")
    if(nlearn3LiveclassPackageId) payload.packageIds= nlearn3LiveclassPackageId;

    setSearchPayload(payload);
    setPage(1);
  }

  const clearFilter = () => {
    setValue("admissionNumber", "");
    setValue("userName","");
    setValue("nlearn3LiveclassPackageId",[]);
    setSearchPayload({});
    setPage(1);
  }

  const filterKeys = [
    "admissionNumber",
    "userName",
    "nlearn3LiveclassPackageId"
  ];

  return (
    <div>
      <Paper elevation={2} sx={{ px: 2, pb: 3, pt: 3 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={nl3LiveclassMasterProperties}
            control={control}
            errors={errors}
            watch={watch}
            setValue={setValue}
            getValues={getValues}
          />

          <ContentRight sx={{ mt: -7 }}>
            <Button
              variant="contained"
              sx={{
                width: "70px",
                height: "40px",
                marginTop: "15px",
                marginRight: "10px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={clearFilter}
              disabled={!hasAtLeastOneValue(watch(), filterKeys) || Object.keys(errors).length > 0}
            >
              clear
            </Button>
            <Button
              variant="contained"
              sx={{
                width: "80px",
                height: "40px",
                marginTop: "15px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={handleSearch}
              disabled={!hasAtLeastOneValue(watch(), filterKeys) || Object.keys(errors).length > 0}
            >
              search
            </Button>
          </ContentRight>
        </Grid>
      </Paper>
    </div>
  );
}
